<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.car_type')"
      filterable
      clearable
      :disabled="disabled"
      :size="size"
      class="d-block"
      :multiple="multiple"
    >
      <el-option
        v-for="(carType, index) in guestCarTypes"
        :key="'guestcarType-' + index"
        :label="carType.type"
        :value="carType.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.guestCarTypes && this.guestCarTypes.length === 0) {
      this.updateInventory();
    }
  },
  computed: {
    ...mapGetters({
      guestCarTypes: "guestCarType/inventory",
    }),
  },
  methods: {
    ...mapActions({
      updateInventory: "guestCarType/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
  },
};
</script>
